import _ from 'lodash';
import REST from '../rest';

const ENDPOINT = 'api/v1/exports';

export const load = (props) => REST.get(
  ENDPOINT,
  _.get(props, 'id'),
  { ...props, include: 'owner' },
);
export const create = (data) => REST.post(ENDPOINT, data);
export const update = (id, data) => REST.patch(ENDPOINT, id, data);
export const deleteExport = (id) => REST.delete(ENDPOINT, id);
